export interface Credentials {
    email: string;
    password: string;
}

export interface CredentialsWithUserInfo extends Credentials {
    firstName: string;
    lastName: string;
    company: string;
    country: string;
    clevertapId: string | null;
    dateOfBirth: string;
    registrationToken: string | undefined;
    languagePreferences: string[];
}

export interface CredentialsWithUserInfoAndTZ extends CredentialsWithUserInfo {
    localTimezone: string | null;
}

export interface ValidateTokenData {
    uidb64: string;
    token: string;
}

export interface ResetPasswordRequiredInfo extends ValidateTokenData {
    password: string;
}

export type SingleSignOnRequestData = Pick<Credentials, 'email'>;

export interface SingleSignOnRequestResponse {
    ssoUrl: string;
}

export enum MemberAccessFlow {
    EMAIL_PW = 'EMAIL_PW',
    EMAIL_PW_SSO = 'EMAIL_PW_SSO',
    SSO = 'SSO',
}

export interface MemberAccessFlowResponse {
    ssoUrl?: string;
    accessFlow: MemberAccessFlow;
}

export interface AuthData {
    access_token: string;
    refresh_token?: string;
    expires_in: number;
    token_type: string;
}

// Represents a JWT returned by Vinz, each attribute is an OAuth claim
export interface JWTData {
    aud: string[];
    exp: number;
    fea: string[];
    iat: number;
    iss: string;
    jti: string;
    rol: string[];
    sub: string;
}

interface Grant {
    grant_type: string;
    scope: string;
}

export interface PasswordGrant extends Grant {
    username: string;
    password: string;
}

export interface RefreshGrant extends Grant {
    refresh_token: string;
}
